module.exports = __webpack_public_path__ + "img/HU12715574.425baaee.png";